<template>
    <v-card
        class="elevation-2"
    >
      <v-toolbar outlined flat dense>
        <v-toolbar-title class="mt-4 mb-4">
          <v-icon>tag</v-icon>
          Phone Numbers
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text v-if="provisionedPhoneNumbers">
        <v-simple-table v-if="provisionedPhoneNumbers.length !== 0">
          <template v-slot:default>
            <thead>
            </thead>
            <tbody>
            <tr
                v-for="item in provisionedPhoneNumbers"
                :key="item.phoneNumber"
                @click="goToNumberDash(item)"
            >
              <td class="font-weight-regular text-h5">
                {{ item.friendlyName }}
              </td>
              <td class="font-weight-bold">{{formatPhoneNumber(item.phoneNumber) }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div v-else>
          <div class="pl-3 pb-2">
            <h2 class="font-weight-bold">Standard Plan</h2>
            <v-divider ></v-divider>
          </div>


          <div v-if="subscription" class="mb-3">
            <ul v-for="feature in subscription.features" :key="feature">
              <h3 class="font-weight-regular pb-3">
                <v-icon>check</v-icon>
                {{feature}}
              </h3>
            </ul>
            <div v-if="subscription" class="pl-3">
              <h2 class="font-weight-bold">Pricing</h2>
              <v-divider></v-divider>
              <h3 class="font-weight-regular pt-2 mb-1">Phone Number: ${{subscription.rates.costPerNumber}} /month</h3>
              <h3 class="font-weight-regular mb-1">Calls: ${{subscription.rates.costPerCall}} /min</h3>
              <h3 class="font-weight-regular mb-1">Texts: ${{subscription.rates.costPerSMS}} /text</h3>
            </div>

          </div>
          <div v-else>
            Add a phone number to continue.
          </div>
        </div>
        <v-card-actions class="mt-3" v-if="provisionedPhoneNumbers.length === 0">
          <v-btn class="outlined text blue" dark router :to="'/getNewPhoneNumber'"><v-icon>add</v-icon>Add a new Number</v-btn>
        </v-card-actions>
      </v-card-text>
      <app-loading class="pa-12" v-else></app-loading>
    </v-card>
</template>
<script>
import {collection, getDocs} from "firebase/firestore";

export default {
  data: () => ({
    provisionedPhoneNumbers: null,
  }),
  computed: {
    subscription () {
      let subs = this.$store.getters.subscriptions
      let phonePlan = null
      // console.log(subs)
      subs.forEach(sub => {
        if (sub.id === 'flexlinePhoneNumber') {
          // console.log(sub)
          phonePlan = sub
        }
      })
      return phonePlan
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    let db = this.$store.state.db
    let numbersRef = getDocs(collection(db, 'users', this.user.uid + '/provisionedNumbers'))
    return numbersRef
        .then (numbers => {
          let numbersList = []
          numbers.forEach (number => {
            numbersList.push(number.data())
          })
          this.provisionedPhoneNumbers = numbersList
          // console.log(numbersList)
        })
  },
  methods: {
    formatPhoneNumber(phoneNumberString) {
      // console.log(phoneNumberString)
      let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        let intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      }
      return null;
    },
    goToNumberDash(selectedNumber) {
      //console.log(selectedNumber)
      if(selectedNumber.status.type !== 'active'){
        this.newNumberDialog = true
        this.selectedNumberMessage = selectedNumber.status.message
      } else {
        this.$router.push('/numberPortal/' + selectedNumber.phoneNumber)
      }

    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

